import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询客户接触渠道
export function listCustomerContactChannel(requestBody) {
  return request({
    url: URL.mdm.basicData.listCustomerContactChannel,
    method: 'post',
    data: requestBody
  })
}

// 新增或更新客户接触渠道
export function saveCustomerContactChannel(requestBody) {
  return request({
    url: URL.mdm.basicData.saveCustomerContactChannel,
    method: 'post',
    data: requestBody
  })
}

// 删除客户接触渠道
export function deleteCustomerContactChannel(requestBody) {
  return request({
    url: URL.mdm.basicData.deleteCustomerContactChannel,
    method: 'post',
    data: requestBody
  })
}

// 获取已被使用的客户接触渠道
export function getUsedCustomerContactChannel(requestBody) {
  return request({
    url: URL.mdm.basicData.getUsedCustomerContactChannel,
    method: 'post',
    data: requestBody
  })
}
